import { FileRecordCategoryEnum } from '../enums/file-record-category.enum';

/**
 * Infer file record category from MIME type for uploads where category is not supplied.
 * Image MIME types map to {@link FileRecordCategoryEnum.IMAGE}; all others to {@link FileRecordCategoryEnum.DOCUMENT}.
 */
export function inferFileRecordCategory(
	mimeType?: string | null,
): FileRecordCategoryEnum {
	if (mimeType?.startsWith('image/')) {
		return FileRecordCategoryEnum.IMAGE;
	}
	return FileRecordCategoryEnum.DOCUMENT;
}
